import React from 'react';
import { useDispatch } from 'react-redux';
import IsLoadingHOC from '../../Components/IsLoadingHOC';
import IsLoggedinHOC from '../../Components/IsLoggedinHOC';
import { addCity } from '../../Redux/action/City';
import { Link, useHistory } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';

function AddCity(props) {
    const { setLoading } = props
    const dispatch = useDispatch()
    const history = useHistory()


    const formik = useFormik({
        initialValues: {
            name: '',
            name_ar: '',
            status: true,
        },

        validationSchema: Yup.object({
            name: Yup.string()
                .required("This fiels is required")
                .min(3, 'This field must be at least 3 characters'),

            name_ar: Yup.string()
                .min(3, 'This field must be at least 3 characters')
                .required("This field is required"),

        }),
        onSubmit: async values => {
            let fieldValues = values
            setLoading(true)
            await dispatch(addCity(fieldValues))
                .then(
                    response => {
                        setLoading(false)
                        if (response.status === '1') {
                            toast.success(response.data.message)
                            formik.resetForm();
                            history.push('/cities')
                        } else {
                            toast.error(response.data.error[0])
                        }
                    },
                    error => {
                        setLoading(false)
                        toast.error(error.response.data?.message)
                    }
                ).catch(error => console.log(error))
        }
    });

    const handleChangeBooleanValue = (e) => {
        let { name, value } = e.target
        value = JSON.parse(value)
        formik.setFieldValue(name, value)
    }

    return (
        <div className="content-wrapper">
            <div className="content-header main_breadcrumb_top">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Create a new City</h1>
                        </div>
                    </div>
                </div>
            </div>
            <section className="content">
                <div className="container-fluid">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-12">
                                    <form onSubmit={formik.handleSubmit} >
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div className="form-group required">
                                                    <label className="control-label">English Name</label>
                                                    <input
                                                        name="name"
                                                        placeholder='English name'
                                                        onBlur={formik.handleBlur}
                                                        onChange={formik.handleChange}
                                                        value={formik.values.name}
                                                        type="text" className="form-control" />
                                                    {formik.touched.name && formik.errors.name ? (<span className="text-danger">{formik.errors.name}</span>) : null}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div className="form-group required">
                                                    <label className="control-label">Arabic Name</label>
                                                    <input
                                                        name="name_ar"
                                                        placeholder='Arabic name'
                                                        onBlur={formik.handleBlur}
                                                        onChange={formik.handleChange}
                                                        value={formik.values.name_ar}
                                                        type="text" className="form-control" />
                                                    {formik.touched.name_ar && formik.errors.name_ar ? (<span className="text-danger">{formik.errors.name_ar}</span>) : null}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div className="form-group">
                                                    <label className="control-label">Status</label>
                                                    <select name='status' className="form-control"
                                                        value={formik.values.status}
                                                        onChange={handleChangeBooleanValue}>
                                                        <option value={true}>Active</option>
                                                        <option value={false}>Inactive</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="pb-5 form-foot-btn">
                                            <Link to="/cities" ><button type="button" className="btn btn-primary mr-2">Back</button></Link>
                                            <button type="submit" className="btn btn-success">Submit</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}
export default IsLoadingHOC(IsLoggedinHOC(AddCity))